<template>
  <div class="ebook-about-section">
    <div class="about-container">
      <!-- Columna izquierda: Contenido -->
      <div class="about-content">
        <div class="content-header">
          <div class="section-badge">
            <div class="badge-line"></div>
            <span class="badge-text">SOBRE FOURIN</span>
          </div>
          <h2 class="main-title">¿Quién está detrás de la guía?</h2>
        </div>

        <p class="intro-text">
          Fourin es un SaaS latinoamericano que ayuda a salir de Excel/WhatsApp para gestionar
          mantenimiento preventivo y predictivo con orden y trazabilidad.
        </p>

        <ul class="features-list">
          <li class="feature-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Gestionar OT con responsables, prioridades y firmas digitales.</span>
          </li>
          <li class="feature-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Recibir alertas en tiempo real y configurar SLAs.</span>
          </li>
          <li class="feature-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Tener trazabilidad completa: historial, evidencias y auditorías.</span>
          </li>
          <li class="feature-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Integrar con tu ERP/contabilidad para facturación inmediata.</span>
          </li>
          <li class="feature-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Acceder a dashboards y reportes listos para decisiones gerenciales.</span>
          </li>
        </ul>

        <button class="download-cta" @click="scrollToForm">
          <span>Descargar ebook</span>
          <svg class="cta-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M7 17L17 7M17 7H7M17 7V17"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Columna derecha: Dashboard cortado -->
      <div class="dashboard-column">
        <div class="dashboard-container">
          <img
            src="@/assets/images/fourin.png"
            alt="Dashboard Fourin Track"
            class="dashboard-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const scrollToForm = () => {
  const formElement = document.querySelector('.ebook-form-section')
  if (formElement) {
    formElement.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped>
.ebook-about-section {
  padding: 80px 20px;
  background: #fff;
  min-height: 60vh;
}

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.about-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.content-header {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-badge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.badge-line {
  width: 40px;
  height: 2px;
  background: #129bef;
}

.badge-text {
  color: #129bef;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-title {
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  margin: 0;
}

.intro-text {
  font-size: 18px;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.features-list {
  list-style: none;
  padding: 0;
  gap: 15px;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.check-icon {
  width: 24px;
  height: 24px;
  background: #129bef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.check-icon .material-symbols-outlined {
  color: #fff;
  font-size: 18px;
}

.feature-item span {
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}

.download-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #129bef;
  color: white;
  border: none;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
  margin-top: 20px;
}

.download-cta:hover {
  background: #0ea5e9;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(18, 155, 239, 0.4);
}

.cta-arrow {
  transition: transform 0.3s ease;
}

.download-cta:hover .cta-arrow {
  transform: translate(2px, -2px);
}

.dashboard-column {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
}

.dashboard-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  height: 400px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.dashboard-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left center;
}

/* Efecto de corte a la derecha */
.dashboard-container::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  background: linear-gradient(to right, transparent, #fff);
  pointer-events: none;
}

@media (max-width: 1024px) {
  .about-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .dashboard-column {
    justify-content: center;
  }

  .dashboard-container {
    max-width: 500px;
    height: 300px;
  }
}

@media (max-width: 768px) {
  .ebook-about-section {
    padding: 60px 15px;
  }

  .about-container {
    gap: 30px;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .intro-text {
    font-size: 16px;
  }

  .feature-item {
    text-align: left;
  }

  .download-cta {
    width: 100%;
    padding: 16px 32px;
    font-size: 16px;
  }

  .dashboard-container {
    max-width: 400px;
    height: 250px;
  }
}

@media (max-width: 480px) {
  .ebook-about-section {
    padding: 40px 10px;
  }

  .features-list {
  }

  .feature-item span {
    font-size: 15px;
  }

  .dashboard-container {
    max-width: 350px;
    height: 200px;
  }
}
</style>
